import { Avatar, makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.primary.main,
        width: 64,
        height: 64,
    },
}));

const StyledAvatar = ({ user }) => {
    const classes = useStyles();

    return <Avatar className={classes.root}>{user.initials}</Avatar>;
};

export default StyledAvatar;
